import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input as ChakraInput,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';

const Input = (
  {
    onChange,
    onBlur,
    value,
    name,
    error,
    label,
    helperText,
    leftElement,
    ...props
  },
  ref,
) => (
  <FormControl isInvalid={!!error}>
    {!!label && (
      <FormLabel fontSize="lg" fontWeight="bold" htmlFor={name}>
        <FormattedMessage {...label} />
      </FormLabel>
    )}
    <InputGroup size={['md', 'lg']}>
      {!!leftElement && (
        <InputLeftElement
          pointerEvents="none"
          color="gray.400"
          fontSize="1.2em"
          h="100%"
          pl={2}
        >
          {leftElement}
        </InputLeftElement>
      )}
      <ChakraInput
        {...props}
        onWheel={event => props.type === 'number' && event.target.blur()}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        isInvalid={!!error}
        ref={ref}
        {...(!!leftElement && {
          // A workaround for this issue: https://github.com/chakra-ui/chakra-ui/issues/5703
          paddingInlineStart: '2.4em !important',
        })}
      />
    </InputGroup>
    {error ? (
      <FormErrorMessage>{error.message}</FormErrorMessage>
    ) : (
      !!helperText && (
        <FormHelperText>
          <FormattedMessage {...helperText} />
        </FormHelperText>
      )
    )}
  </FormControl>
);

const ForwardWithRef = forwardRef(Input);

export { ForwardWithRef as Input };
